import { render, staticRenderFns } from "./TheCheckout.vue?vue&type=template&id=2a1b7d17&scoped=true"
import script from "./TheCheckout.vue?vue&type=script&lang=js"
export * from "./TheCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b7d17",
  null
  
)

export default component.exports